export default __webpack_public_path__ + "static/media/Care07.843dfd54.png";